(function () {
  let makeLogoMap = null;
  let vehicleTypesMap = null;
  let vehicleTypesPromise = null;

  function getMakeLogoMap() {
    if (makeLogoMap) return makeLogoMap;

    makeLogoMap = new Map();
    const registry = document.getElementById('menu-make-logos');
    if (!registry) return makeLogoMap;

    registry.querySelectorAll('[data-make-logo]').forEach((entry) => {
      const title = entry.dataset.title?.trim().toLowerCase();
      if (!title || !entry.dataset.src) return;
      makeLogoMap.set(title, {
        src: entry.dataset.src,
        alt: entry.dataset.alt || title,
        width: entry.dataset.width,
        height: entry.dataset.height,
      });
    });

    return makeLogoMap;
  }

  function loadVehicleTypes(url) {
    if (vehicleTypesMap) return Promise.resolve(vehicleTypesMap);
    if (!url) {
      vehicleTypesMap = {};
      return Promise.resolve(vehicleTypesMap);
    }
    if (vehicleTypesPromise) return vehicleTypesPromise;

    vehicleTypesPromise = fetch(url)
      .then((response) => (response.ok ? response.json() : {}))
      .then((data) => {
        vehicleTypesMap = data && typeof data === 'object' ? data : {};
        return vehicleTypesMap;
      })
      .catch(() => {
        vehicleTypesMap = {};
        return vehicleTypesMap;
      });

    return vehicleTypesPromise;
  }

  function applyMakeLogos(root) {
    const logos = getMakeLogoMap();
    if (!logos.size) return;

    root.querySelectorAll('[data-make-logo-slot]').forEach((slot) => {
      const title = slot.dataset.makeLogoTitle?.trim().toLowerCase();
      const logo = title ? logos.get(title) : null;
      if (!logo) return;

      const img = document.createElement('img');
      img.src = logo.src;
      img.alt = logo.alt;
      img.className = 'mega-menu-tiered__make-logo';
      img.width = Number(logo.width) || 40;
      img.height = Number(logo.height) || 40;
      img.loading = 'eager';

      slot.replaceWith(img);
    });
  }

  function initScrollAreas(root) {
    root.querySelectorAll('[data-mega-menu-scroll]').forEach((scrollEl) => {
      if (scrollEl.dataset.scrollInitialized === 'true') return;
      scrollEl.dataset.scrollInitialized = 'true';

      let scheduled = false;
      const update = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          const { scrollTop, scrollHeight, clientHeight } = scrollEl;
          scrollEl.classList.toggle('has-scroll-below', scrollTop + clientHeight < scrollHeight - 4);
        });
      };

      scrollEl._scrollUpdate = update;
      scrollEl.addEventListener('scroll', update, { passive: true });

      if (!scrollEl.hasAttribute('data-scroll-lite') && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(update).observe(scrollEl);
      }

      update();
    });
  }

  function initTypeIcons(root) {
    root.querySelectorAll('img[data-type-icon]').forEach((img) => {
      const deferredSrc = img.dataset.src;
      if (deferredSrc && !img.getAttribute('src')) {
        img.src = deferredSrc;
        img.removeAttribute('data-src');
      }
    });
  }

  function bindMenuScrollRefresh(root) {
    const menu = root.closest('.mega-menu--shop-by-category');
    if (!menu || menu.dataset.menuScrollBound === 'true') return;
    menu.dataset.menuScrollBound = 'true';

    menu.addEventListener('mouseenter', () => {
      root.querySelectorAll('[data-mega-menu-scroll]').forEach((el) => el._scrollUpdate?.());
    });
  }

  function resetScrollArea(root, selector) {
    const scrollEl = root.querySelector(selector);
    if (!scrollEl) return;
    scrollEl.scrollTop = 0;
    scrollEl._scrollUpdate?.();
  }

  function bindTieredActivate(item, handler) {
    item.addEventListener('mouseenter', handler);
    item.addEventListener('focus', handler);

    if (item.matches('button, [role="button"]')) {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        handler();
      });
    }
  }

  function typeValueToSlug(typeValue) {
    return (typeValue || '').trim().replace(/\s+/g, '-').toLowerCase();
  }

  function normalizeTypeSlug(value) {
    return typeValueToSlug(value);
  }

  function stripPluralSlug(slug) {
    return slug.replace(/s$/, '');
  }

  function typesMatch(menuType, availableType) {
    const menu = (menuType || '').trim();
    const available = (availableType || '').trim();
    if (!menu || !available) return false;
    if (menu.toLowerCase() === available.toLowerCase()) return true;

    const menuSlug = normalizeTypeSlug(menu);
    const availSlug = normalizeTypeSlug(available);
    if (menuSlug === availSlug) return true;
    if (menuSlug === `${availSlug}s` || availSlug === `${menuSlug}s`) return true;

    return stripPluralSlug(menuSlug) === stripPluralSlug(availSlug);
  }

  function parseAvailableTypes(link) {
    if (link?.dataset && 'availableTypes' in link.dataset) {
      const raw = link.dataset.availableTypes;
      if (raw === '') return [];
      return raw.split('|').map((type) => type.trim()).filter(Boolean);
    }

    if (!vehicleTypesMap) return null;

    const handle = link?.dataset?.collectionHandle?.trim();
    if (!handle || !Object.prototype.hasOwnProperty.call(vehicleTypesMap, handle)) {
      return null;
    }

    const types = vehicleTypesMap[handle];
    return Array.isArray(types) ? types : null;
  }

  function findMatchingAvailableType(menuTypeValue, availableTypes) {
    if (!availableTypes?.length) return null;
    return availableTypes.find((type) => typesMatch(menuTypeValue, type)) || null;
  }

  function linkHasType(types, typeValue) {
    if (types === null) return true;
    if (!types.length) return false;
    return Boolean(findMatchingAvailableType(typeValue, types));
  }

  function buildTypeFilterCache(root, typeItems) {
    const makeLis = Array.from(root.querySelectorAll('.mega-menu-tiered__makes-list > li[data-mega-menu-filter-item]'));
    const seriesLis = Array.from(root.querySelectorAll('.mega-menu-tiered__series-panel li[data-mega-menu-filter-item]'));
    const modelEntries = Array.from(getModelLinks(root)).map((link) => ({
      link,
      li: link.closest('li[data-mega-menu-filter-item]'),
      types: parseAvailableTypes(link),
      baseUrl: link.dataset.collectionUrl || link.getAttribute('href') || '',
    }));

    const modelsByMakeSeries = new Map();
    root.querySelectorAll('.mega-menu-tiered__models-panel').forEach((panel) => {
      const key = `${panel.dataset.makePanel}-${panel.dataset.seriesPanel}`;
      modelsByMakeSeries.set(
        key,
        modelEntries.filter(({ link }) => link.closest('[data-series-panel]') === panel)
      );
    });

    const makeHasType = (makeIndex, typeValue) => {
      const seriesForMake = seriesLis.filter((li) => {
        const btn = li.querySelector('[data-series-index]');
        return btn && parseInt(btn.dataset.makeIndex, 10) === makeIndex;
      });

      if (seriesForMake.length) {
        return seriesForMake.some((li) => {
          const btn = li.querySelector('[data-series-index]');
          const key = `${makeIndex}-${btn.dataset.seriesIndex}`;
          return (modelsByMakeSeries.get(key) || []).some((entry) => linkHasType(entry.types, typeValue));
        });
      }

      return modelEntries.some(
        (entry) =>
          parseInt(entry.link.closest('[data-make-panel]')?.dataset.makePanel || '-1', 10) === makeIndex &&
          linkHasType(entry.types, typeValue)
      );
    };

    const cache = new Map();

    typeItems.forEach((typeItem) => {
      const typeValue = typeItem.dataset.typeValue || '';
      const makes = makeLis.map((li) => {
        const btn = li.querySelector('[data-make-index]');
        const makeIndex = parseInt(btn.dataset.makeIndex, 10);
        return { li, visible: makeHasType(makeIndex, typeValue) };
      });

      const series = seriesLis.map((li) => {
        const btn = li.querySelector('[data-series-index]');
        const makeIndex = parseInt(btn.dataset.makeIndex, 10);
        const seriesIndex = parseInt(btn.dataset.seriesIndex, 10);
        const key = `${makeIndex}-${seriesIndex}`;
        const visible = (modelsByMakeSeries.get(key) || []).some((entry) => linkHasType(entry.types, typeValue));
        return { li, visible };
      });

      const models = modelEntries.map((entry) => ({
        li: entry.li,
        visible: linkHasType(entry.types, typeValue),
      }));

      const linkHrefs = new Map();
      modelEntries.forEach((entry) => {
        if (!linkHasType(entry.types, typeValue)) return;
        const matched = findMatchingAvailableType(typeValue, entry.types);
        const slug = typeValueToSlug(matched || typeValue);
        linkHrefs.set(entry.link, buildCollectionTypeUrl(entry.baseUrl, slug));
      });

      cache.set(typeValue, { makes, series, models, linkHrefs });
    });

    return cache;
  }

  function setFilterVisibility(items, visible) {
    items.forEach((item) => {
      item.classList.toggle('is-filter-hidden', !visible);
      item.toggleAttribute('hidden', !visible);
    });
  }

  function applyTypeFilter(root, typeValue) {
    const state = root._typeFilterCache?.get(typeValue);
    if (!state) return;

    state.makes.forEach(({ li, visible }) => setFilterVisibility([li], visible));
    state.series.forEach(({ li, visible }) => setFilterVisibility([li], visible));
    state.models.forEach(({ li, visible }) => setFilterVisibility([li], visible));
  }

  function updateModelLinks(root, typeValue) {
    const linkHrefs = root._typeFilterCache?.get(typeValue)?.linkHrefs;
    if (!linkHrefs) return;
    linkHrefs.forEach((href, link) => link.setAttribute('href', href));
  }

  function buildCollectionTypeUrl(collectionUrl, typeSlug) {
    if (!collectionUrl || !typeSlug) return collectionUrl || '';

    try {
      const url = new URL(collectionUrl, window.location.origin);
      const match = url.pathname.match(/^(.*\/collections\/[^/]+)/);
      const basePath = match ? match[1] : url.pathname.replace(/\/$/, '');
      return `${basePath}/${typeSlug}`;
    } catch {
      const basePath = collectionUrl.split('?')[0].replace(/\/$/, '');
      return `${basePath}/${typeSlug}`;
    }
  }

  function getModelLinks(root) {
    return root.querySelectorAll('.mega-menu-tiered__model-item[data-collection-handle]');
  }

  function initMegaMenuTieredCategory(root) {
    if (!root) return;

    const typeItems = root.querySelectorAll('.mega-menu-tiered__type-item[data-type-index]');
    if (!typeItems.length) return;

    if (root.dataset.tieredCategoryInitialized === 'true') return;
    root.dataset.tieredCategoryInitialized = 'true';

    applyMakeLogos(root);
    initScrollAreas(root);
    initTypeIcons(root);
    bindMenuScrollRefresh(root);

    const makeItems = root.querySelectorAll('.mega-menu-tiered__make-item[data-make-index]');
    const makePanels = root.querySelectorAll('[data-make-panel].mega-menu-tiered__series-panel');
    const seriesItems = root.querySelectorAll('.mega-menu-tiered__series-item[data-series-index]');
    const modelPanels = root.querySelectorAll('[data-series-panel].mega-menu-tiered__models-panel');
    const typeHeading = root.querySelector('[data-mega-menu-type-heading]');
    const makeHeading = root.querySelector('[data-mega-menu-make-heading]');
    const seriesHeading = root.querySelector('[data-mega-menu-series-heading]');

    let activeTypeItem = typeItems[0];
    let activeTypeValue = activeTypeItem?.dataset.typeValue || '';

    let activeMakeIndex = null;
    let activeSeriesKey = null;

    function getMakeIndex(item) {
      return parseInt(item.dataset.makeIndex, 10);
    }

    function getSeriesIndex(item) {
      return parseInt(item.dataset.seriesIndex, 10);
    }

    function getItemTitle(item) {
      return (
        item.dataset.typeTitle ||
        item.dataset.makeTitle ||
        item.dataset.seriesTitle ||
        item.querySelector('.mega-menu-tiered__type-item-text, .mega-menu-tiered__make-item-text, .mega-menu-tiered__series-item-text')?.textContent?.trim() ||
        ''
      );
    }

    function isFilterItemHidden(item) {
      const li = item.closest('li[data-mega-menu-filter-item]');
      return Boolean(li?.classList.contains('is-filter-hidden') || li?.hasAttribute('hidden'));
    }

    function setMakeActiveState(makeIndex) {
      makeItems.forEach((item) => {
        const isActive =
          makeIndex != null && !isFilterItemHidden(item) && getMakeIndex(item) === makeIndex;
        item.classList.toggle('is-active', isActive);
        if (item.hasAttribute('aria-controls')) {
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });
    }

    function clearSeriesModelSelection() {
      activeSeriesKey = null;

      seriesItems.forEach((item) => {
        item.classList.remove('is-active');
        if (item.hasAttribute('aria-controls')) {
          item.setAttribute('aria-expanded', 'false');
        }
      });

      modelPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', '');
      });

      if (seriesHeading) {
        seriesHeading.textContent = '';
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--models');
      root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
      root.querySelector('.mega-menu-tiered__scroll--models')?._scrollUpdate?.();
    }

    function clearMakeSeriesSelection() {
      activeMakeIndex = null;
      setMakeActiveState(null);

      makePanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', '');
      });

      if (makeHeading) {
        makeHeading.textContent = '';
      }

      clearSeriesModelSelection();
      resetScrollArea(root, '.mega-menu-tiered__scroll--series');
      root.querySelector('.mega-menu-tiered__scroll--makes')?._scrollUpdate?.();
    }

    function activateMake(makeIndex, force) {
      if (!force && activeMakeIndex === makeIndex) return;
      activeMakeIndex = makeIndex;
      activeSeriesKey = null;

      setMakeActiveState(makeIndex);

      makePanels.forEach((panel) => {
        const panelMake = parseInt(panel.dataset.makePanel, 10);
        const isActive = panelMake === makeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      const activeMake = root.querySelector(
        `.mega-menu-tiered__make-item[data-make-index="${makeIndex}"]:not(.is-filter-hidden)`
      );
      if (makeHeading && activeMake) {
        makeHeading.textContent = getItemTitle(activeMake);
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--series');
      clearSeriesModelSelection();
      root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
    }

    function activateSeries(makeIndex, seriesIndex, force) {
      const seriesKey = `${makeIndex}-${seriesIndex}`;
      if (!force && activeSeriesKey === seriesKey) return;
      activeSeriesKey = seriesKey;

      const scopedSeriesItems = root.querySelectorAll(
        `.mega-menu-tiered__series-panel[data-make-panel="${makeIndex}"] .mega-menu-tiered__series-item[data-series-index]`
      );

      scopedSeriesItems.forEach((item) => {
        const isActive = !isFilterItemHidden(item) && getSeriesIndex(item) === seriesIndex;
        item.classList.toggle('is-active', isActive);
        if (item.hasAttribute('aria-controls')) {
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      modelPanels.forEach((panel) => {
        const panelMake = parseInt(panel.dataset.makePanel, 10);
        const panelSeries = parseInt(panel.dataset.seriesPanel, 10);
        const isActive = panelMake === makeIndex && panelSeries === seriesIndex;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      const activeSeries = root.querySelector(
        `.mega-menu-tiered__series-panel[data-make-panel="${makeIndex}"] .mega-menu-tiered__series-item[data-series-index="${seriesIndex}"]`
      );
      if (seriesHeading && activeSeries) {
        seriesHeading.textContent = getItemTitle(activeSeries);
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--models');
      root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
      root.querySelector('.mega-menu-tiered__scroll--models')?._scrollUpdate?.();
    }

    function activateType(typeItem, force) {
      const typeValue = typeItem.dataset.typeValue || '';
      if (!force && activeTypeItem === typeItem) return;

      if (activeTypeItem && activeTypeItem !== typeItem) {
        activeTypeItem.classList.remove('is-active');
        activeTypeItem.setAttribute('aria-expanded', 'false');
      }

      activeTypeItem = typeItem;
      activeTypeValue = typeValue;
      typeItem.classList.add('is-active');
      typeItem.setAttribute('aria-expanded', 'true');

      if (typeHeading) {
        typeHeading.textContent = getItemTitle(typeItem);
      }

      applyTypeFilter(root, typeValue);
      updateModelLinks(root, typeValue);
      clearMakeSeriesSelection();
      root.querySelector('.mega-menu-tiered__scroll--types')?._scrollUpdate?.();
    }

    function rebuildTypeFilterCache() {
      root._typeFilterCache = buildTypeFilterCache(root, typeItems);
      if (activeTypeItem) {
        activateType(activeTypeItem, true);
      }
    }

    root._typeFilterCache = buildTypeFilterCache(root, typeItems);

    typeItems.forEach((item) => {
      item.addEventListener('mouseenter', () => activateType(item));
      item.addEventListener('focus', () => activateType(item));
    });

    makeItems.forEach((item) => {
      bindTieredActivate(item, () => {
        const li = item.closest('li[data-mega-menu-filter-item]');
        if (li?.classList.contains('is-filter-hidden')) return;
        activateMake(getMakeIndex(item));
      });
    });

    seriesItems.forEach((item) => {
      bindTieredActivate(item, () => {
        const li = item.closest('li[data-mega-menu-filter-item]');
        if (li?.classList.contains('is-filter-hidden')) return;
        activateSeries(getMakeIndex(item), getSeriesIndex(item));
      });
    });

    activateType(typeItems[0], true);

    const typesUrl = root.dataset.vehicleTypesUrl;
    loadVehicleTypes(typesUrl).then(() => {
      if (!root.isConnected) return;
      rebuildTypeFilterCache();
    });
  }

  function tryInitCategoryMenu(menu) {
    const root = menu.querySelector('[data-mega-menu-tiered-category]');
    if (!root) return false;
    initMegaMenuTieredCategory(root);
    return root.dataset.tieredCategoryInitialized === 'true';
  }

  function prefetchCategoryMenuContent(menu) {
    const fetcher = menu.querySelector('section-fetcher[data-activate="interaction"]');
    if (fetcher && typeof fetcher.initialize === 'function') {
      fetcher.initialize();
    }
  }

  function bindLazyCategoryMenuInit() {
    document.querySelectorAll('.mega-menu--shop-by-category').forEach((menu) => {
      if (menu.dataset.categoryLazyInitBound === 'true') return;
      menu.dataset.categoryLazyInitBound = 'true';

      const summary = menu.querySelector('.details__summary');

      const ensureReady = () => {
        if (tryInitCategoryMenu(menu)) return;
        const onCached = () => {
          if (tryInitCategoryMenu(menu)) {
            document.removeEventListener('section:cached', onCached);
          }
        };
        document.addEventListener('section:cached', onCached, { once: false });
      };

      summary?.addEventListener(
        'mouseenter',
        () => {
          prefetchCategoryMenuContent(menu);
        },
        { passive: true }
      );

      menu.addEventListener('mouseenter', () => {
        prefetchCategoryMenuContent(menu);
        ensureReady();
      });

      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        prefetchCategoryMenuContent(menu);
        ensureReady();
      });
    });
  }

  function onSectionRefresh() {
    makeLogoMap = null;
    bindLazyCategoryMenuInit();
    document.querySelectorAll('.mega-menu--shop-by-category').forEach((menu) => {
      if (!menu.open && !menu.matches(':hover')) return;
      tryInitCategoryMenu(menu);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLazyCategoryMenuInit);
  } else {
    bindLazyCategoryMenuInit();
  }

  document.addEventListener('shopify:section:load', onSectionRefresh);
  document.addEventListener('section:cached', onSectionRefresh);
})();
